import React from "react";
import { styled } from "@mui/system";
import {
  Title, Subtitle, CTASection, CTAText, SectionContainer,
  Description
} from "../assets/styles/ContentStyles"
import EmailInputComponent from "./EmailInputComponent";

const CybersecurityExperts = () => {

  return (
    <SectionContainer>
      <Title>
        Built by Cybersecurity Experts using the Industry's Gold Standard of
        Vulnerability Intelligence
      </Title>

      <Description>
        Hackable Devices uses the Exploit Prediction Scoring System (EPSS), the same framework
        trusted by cybersecurity professionals and Fortune 500 companies to assess vulnerability
        risk.
      </Description>

      <Description>
        We translate enterprise-grade security monitoring into protection that works for everyone
        from tech enthusiasts to busy parents who just want their family to be safe online.
      </Description>

      <CTASection>
        <CTAText>
          Get real-time device security monitoring & patching from Hackable Devices.
        </CTAText>

        <EmailInputComponent
          waitlistType="Cybersecurity Experts - Device Security Monitoring"
        />
      </CTASection>
    </SectionContainer>
  );
};

export default CybersecurityExperts;
